import { render } from "./ProductInOrderCard.vue?vue&type=template&id=4dec4d79&scoped=true"
import script from "./ProductInOrderCard.vue?vue&type=script&lang=js"
export * from "./ProductInOrderCard.vue?vue&type=script&lang=js"

import "./ProductInOrderCard.vue?vue&type=style&index=0&id=4dec4d79&lang=scss&scoped=true"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-4dec4d79"]])

export default __exports__